import { Footer2021, Header2021, use2021Page } from './shared';
import { sponsorsContent2021 } from './data';

const Sponsors2021 = () => {
  const { lang } = use2021Page('Smart Living Partnership Awards 2021 - Sponsors');
  return (
    <>
      <Header2021 lang={lang} currentPath="sponsors" />
      <main>
        <div className="background-container" style={{ backgroundImage: 'url(/2021/images/sponsors.png)', marginTop: '8.1%' }}>
          <img src="/2021/images/sponsors.png" style={{ visibility: 'hidden' }} alt="" />
        </div>
        <div className="sponsors-container background-container" style={{ backgroundImage: 'url(/2021/images/sponsors2.png)', marginTop: '-5px', marginBottom: '-5px' }}>
          <img className="sponsors-bottom" src="/2021/images/sponsors2.png" style={{ visibility: 'hidden' }} alt="" />
          <div className="sponsors-continer background-info">
            <h1><b>{lang === 'zh' ? '贊助' : 'Sponsor'}</b></h1>
            <p style={{ whiteSpace: 'pre-line' }}>{sponsorsContent2021.leadIn[lang]}</p>
            <div className="public_exposure_container">
              <div className="public_container" style={{ position: 'relative', width: '46%', marginTop: 50, paddingRight: 20, borderRight: '3px solid #eeeeee', display: 'inline-block' }}>
                <p>{sponsorsContent2021.methodIntro[lang]}</p>
                <p style={{ marginTop: 30, fontWeight: 'bold' }}>
                  {sponsorsContent2021.method[lang].map((x) => (<span key={x}>• {x}<br /></span>))}
                </p>
              </div>
              <div className="exposure_container" style={{ width: '46%', position: 'relative', float: 'right', marginLeft: 20, display: 'inline-block', marginTop: 50 }}>
                <p>{sponsorsContent2021.targetIntro[lang]}</p>
                <p style={{ marginTop: 40, fontWeight: 'bold' }}>
                  {sponsorsContent2021.target[lang].map((x) => (<span key={x}>• {x}<br /></span>))}
                </p>
              </div>
              <div style={{ marginTop: 30 }}>
                <div style={{ width: '15%', display: 'inline-block' }}>
                  <p><b>{lang === 'zh' ? '協辦機構' : 'Co-organiser'}</b></p>
                  <img style={{ width: '85%' }} src="/2021/images/cyberport.png" alt="Co-organiser" />
                </div>
                <div style={{ width: '25%', display: 'inline-block', verticalAlign: 'top' }}>
                  <p><b>{lang === 'zh' ? '合作夥伴' : 'Partners'}</b></p>
                  <img style={{ width: '45%' }} src="/2021/images/KPMG.png" alt="Partner" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer2021 lang={lang} />
    </>
  );
};

export default Sponsors2021;
